/* i18n语言包（英语） */

export default {
'sys.operator.success': 'sys.operator.success',
'业务异常': 'Business Exception',
'网络请求失败，请稍候再试': 'Network request failed, please try again later',
'请输入公司关键词': 'Please enter company keywords',
'公司名不能为空': 'Company name cannot be empty',
'请输入用户名': 'Please enter a name',
'用户名不能为空': 'Name cannot be empty',
'请输入密码': 'Please enter the password',
'密码不能为空': 'Password cannot be empty',
'长度在 6 到 20 个字符': 'Length between 6 and 20 characters',
'登录': 'log on',
'退出登录': 'Log out of login',
'登录成功': 'Login succeeded',
'登录失败': 'Login failed',
'暂无权限，请联系后台管理员': 'No permission currently, please contact the backend administrator',
'向右滑动完成拼图': 'Slide right to complete the puzzle',
'刷新': 'Refresh',
'抱歉！': 'Sorry!',
'当前页面不存在...': 'The current page does not exist...',
'请检查您输入的网址是否正确，或点击下面的按钮返回首页。': 'Please check if the website address you entered is correct, or click the button below to return to the homepage.',
'登录状态已过期，请重新登录!': 'Login status has expired, please log in again!',
'返回首页': 'Back homePage',
'关闭其他': 'Close Other', 
'关闭左侧': 'Close Left side', 
'关闭右侧': 'Close Right Side', 
'关闭全部': 'Close All', 
'搜索': 'Search',
'清空': 'Empty',
'添加': 'Add',
'删除': 'Delete',
'批量删除': 'Batch Delete',
'确定': 'determine',
'取消': 'cancel',
'启用': 'Enable',
'禁用': 'Disable',
'编辑': 'Edit',
'修改': 'Modify',
'审核': 'Approve',
'反审核': 'De-approval',
'条码': 'bar code',
'详情': 'Details',
'导出Excel': 'Export to Excel',
'边框': 'Border',
'大': 'Large',
'中': 'Medium',
'小': 'Small',
'的订单已签收': "'s order has been signed for ",
'，未签收': ' but not Unsigned ',
'记住账号密码': 'Remember account password',
'MES制造执行系统': 'manufacturing execution system ',
'委外订单': 'Outsourced orders',
'请输入订单号': 'Please enter the order number',
'请选择客户': 'Please select a customer',
'请选择订单状态': 'Please select order status',
'单据状态': 'Document Status ',
'订单金额合计': 'Total order amount',
'预计交货时间': 'Estimated delivery time',
'单据日期': 'Document date',
'已审核': 'Approved',
'未审核': 'Unaudited',
'查询': 'query',
'导出excel成功！': 'Export to Excel successful!',
'下达订单': 'Order placement',
'确认要删除该数据吗？': 'Are you sure you want to delete this data?',
'提示': 'Tip',
'待下单': 'Pending order placement',
'已下单': 'Ordered',
'已确认': 'Confirmed',
'已排期': 'Scheduled',
'生产中': 'In production',
'已完工': 'Completed',
'已出货': 'Shipped',
'已签收': 'Signed for',
'已结算': 'Settled',
'已关闭': 'CLOSED',
'开始时间': 'start time',
'结束时间': 'End time',
'至': 'to',
'序号': 'Number',
'客户名称': 'Customer Name',
'创建人': 'Creator',
'暂无数据': 'There is currently no data available',
'操作': 'operation',
'订单编号': 'Order number',
'订单类型': 'Order type',
'订单状态': 'Order status',
'试产': 'Trial production',
'批量': 'batch',
'结算方式': 'Settlement method',
'现结': 'cash settlement',
'月结': 'Monthly settlement',
'季结': 'Seasonal knot',
'年结': 'Annual closing',
'添加委外订单': 'Add outsourcing orders',
'编辑委外订单': 'Edit outsourcing orders',
'请输入订单编号': 'Please enter the order number',
'请选择订单类型': 'Please select order type',
'请选择结算方式': 'Please select the settlement method',
'请选择预计交货时间': 'Please select the estimated delivery time',
'请输入': 'Please enter',
'请选择': 'Please select',
'上传BOM文件': 'Upload BOM file',
'过账标记': 'Posting mark',
'过账人': 'Posted by',
'过账时间': 'Posting time',
'进度': 'schedule',
'生产工单': 'Production work order',
'生产计划': 'Production plan',
'操作人': 'Operator',
'订单签收': 'Order Receipt',
'签收状态': 'Signing status',
'送货单号': 'Delivery note number',
'成品名称': 'Product Name',
'规格': 'specifications',
'送货数': 'Delivery quantity',
'签收成功': 'Received successfully',
'请选择送货单号': 'Please select delivery note number',
'返回': 'return',
'委外订单编号': 'Outsourcing order number',
'保存': 'preserve',
'添加明细': 'Add details',
'物料编号': 'Material number',
'请选择物料编号': 'Please select the material number',
'物料名称': 'Material Name',
'物料规格': 'Material specifications',
'单位': 'unit',
'数量': 'quantity',
'请输入数量': 'Please enter the quantity',
'单价': 'unit price',
'请输入单价': 'Please enter the unit price',
'含税单价': 'Unit price including tax',
'含税合计': 'Total including tax',
'税率（%）': 'Tax rate (%)',
'请输入税率': 'Please enter the tax rate',
'税额': 'Tax amount',
'备注': 'Remarks',
'销售订单详情': 'Sales order details',
'请选择物料': 'Please select the material',
'请输入物料编号': 'Please enter the material number',
'请输入物料名称': 'Please enter the material name',
'提示：双击选择物料！': 'Tip: Double click to select material!',
'确认要删除选中数据吗？': 'Are you sure you want to delete the selected data?',
'操作成功！': 'Operation successful!',
'品名/型号': 'Product Name/Model',
'请输入品名/型号': 'Please enter product name/model',
'云端工厂': 'Cloud factory',
'请输入PCB条码': 'Please input PCB barcode',
'请输入客户条码': 'Please enter the customer barcode',
'请输入工令单号': 'Please enter the work order number',
'请选择线别': 'Please select the line type',
'请输入计划序号': 'Please enter the plan number',
'请输入机器编号': 'Please enter the machine number',
'请输入客户订单号': 'Please enter the customer order number',
'请选择结果': 'Please select the result',
'PCB条码': 'PCB barcode',
'板面': 'Board surface',
'客户条码': 'Customer barcode',
'工令单号': 'Work order number',
'成品编号': 'Finished product number',
'成品规格': 'Finished product specifications',
'线别名称': 'Line name',
'线别编号': 'Line number',
'计划序号': 'Plan Number',
'客户订单': 'Customer orders',
'结果': 'result',
'供应商名称': 'Supplier Name',
'供应商编号': 'Supplier Number',
'机器编号': 'Machine number',
'备注信息': 'Remarks',
'创建时间': 'Creation time',
'备述': 'Preparation',
'更新时间': 'Update time',
'更新人': 'Updated by',
'请选择结算状态': 'Please select settlement status',
'未结算': 'Unsettled',
'订单完结': 'Order completion',
'成品料号': 'Finished product part number',
'订单金额': 'Order amount',
'结算状态': 'Settlement status',
'未付金额': 'Unpaid amount',
'已付金额': 'amount paid ',
'生产计划序号': 'Production Plan Number',
'完工收货日期': 'Completion and receipt date',
'请输入生产日期(D/C)': 'Please enter the production date (D/C)',
'请输入仓库': 'Please enter the warehouse',
'请选择来料类型': 'Please select the type of incoming material',
'请输入条码编号': 'Please enter the barcode number',
'请输入规格描述': 'Please enter a specification description',
'请输入客户': 'Please enter the customer',
'请输入储位': 'Please enter storage location',
'请输入批次号': 'Please enter the batch number',
'请选择超期状态': 'Please select overdue status',
'已超期': 'Expired',
'未超期': 'Not overdue',
'请选择料架': 'Please select a material rack',
'请选择条码状态': 'Please select barcode status',
'超期': 'Overdue',
'请输入特殊物料': 'Please enter special materials',
'请选择仓库': 'Please select a warehouse',
'锁定状态': 'Locked state',
'条码状态': 'Barcode status',
'超期状态': 'Overdue status',
'条码号': 'barcode ',
'货架编号': 'Shelf number',
'储位': 'Storage space',
'生产日期(D/C)': 'Production date (D/C)',
'D/C': 'D/C',
'周期': 'cycle',
'客户编号': 'Customer Number',
'规格描述': 'Specification Description',
'特殊物料': 'Special materials',
'仓库编号': 'Warehouse number',
'仓库名称': 'Warehouse name',
'备料单日志': 'Material preparation log',
'来料类型': 'Type of incoming materials',
'单位名称': 'Unit Name',
'批次': 'batch',
'入库时间': 'Storage time',
'参考储位': 'Reference storage location',
'有效日期': 'Effective date',
'按条码': 'By barcode',
'按物料编号汇总': 'Summarize by material number',
'按条码导出': 'Export by barcode',
'按物料编号汇总导出': 'Summarize and export by material number',
'炉后AOI记录': 'AOI record after furnace',
'品质追溯': 'Quality traceability',
'对账管理': 'Account reconciliation management',
'物料库存': 'Material inventory',
'数量计算': 'Quantity calculation',
'数量总和': 'Total quantity',
'委外订单详情': 'Outsourcing order details',
'是否签收': 'Whether to sign for it or not',
'未签收':'Unsigned',
'已出库': 'Outbound',
'成品出库数': 'Finished product outbound quantity',
'出库单号': 'Delivery note number',
'出库数量': 'Outbound quantity',
'出库时间': 'Outbound time',
'请先勾选需要删除的数据！': 'Please check the data that needs to be deleted first!',
'请填写必填项！': 'Please fill in the required fields!',
'列表为空，请添加数据！': 'The list is empty, please add data!',
'对账管理详情': 'Reconciliation Management Details',
'请输入规格': 'Please enter the specifications',
'请输入单位': 'Please enter the unit',
'添加物料': 'Add materials',
'编辑物料': 'Edit Material',
'请输入物料规格': 'Please enter the material specifications',
'关闭订单': 'Close order',
'确认要关闭该订单吗？': 'Are you sure you want to close this order?',
'订单': 'order',
'物料资料': 'Material information',
'物料尺寸': 'Material size',
'归属客户编号': 'Belonging customer number',
'归属客户': 'Belonging to customers',
'客户': 'customer',
'物料类型': 'Material type',
'物料类别': 'Material category',
'湿敏元件等级': 'Humidity sensitive element level',
'工艺路线': 'Process route',
'默认供应商': 'Default supplier',
'MRP类别': 'MRP category',
'包装数': 'Number of packages',
'最大数量': 'Maximum quantity',
'最小数量': 'Minimum quantity',
'描述': 'describe',
'物料详情': 'Material details',
'签收详情': 'Signing details',
'工单编号': 'Work Order Number',
'送货时间': 'Delivery time',
'签收': 'sign for',
'全部签收': 'Sign for All',
'下单时间': 'Order time ',
'全部签收时间': 'All signing times',
'结算时间': 'Settlement time',
'关闭时间': 'Closing time',
'关闭': 'close',
'添加其他费用明细': 'Add other expense details',
'SPI': 'SPI',
'pcb条码号': 'PCB barcode number',
'条码序号': 'Barcode number',
'条码数量': 'Number of barcodes',
'DC号': 'DC number',
'生产数量': 'Production quantity',
'站位': 'Standing position',
'位号': 'Tag number',
'操作类型': 'Operation type',
'SMT板用料': 'SMT board materials',
'批号': 'Batch number',
'锡膏': 'Solder paste',
'客户单号': 'Customer tracking number',
'有效时间': 'Effective time',
'失效时间': 'Expiration time',
'钢网': 'Steel mesh',
'钢网编号': 'Steel mesh number',
'最大使用次数': 'Maximum usage times',
'已使用次数': 'Used times',
'张力1': 'Tension 1',
'张力2': 'Tension 2',
'张力3': 'Tension 3',
'张力4': 'Tension 4',
'张力5': 'Tension 5',
'pcb料号': 'PCB part number',
'pcb名称': 'PCB name',
'pcb规格': 'PCB specifications',
'客户订单号': 'Customer order number',
'类别': 'Category',
'DIP用料': 'DIP materials',
'新建用户': 'New User',
'新建时间': 'New Time',
'先进先出码': 'First in, first out code',
'板序号': 'Board number',
'插件过站': 'Plug in stop',
'后焊过站': 'Post weld station',
'烧录过站': 'Burn over station',
'测试过站': 'Test Station Passing',
'包装过站': 'Packaging passing through the station',
'成品入库': 'Finished product warehousing',
'成品出库': 'Finished product outbound',
'维修管理': 'Maintenance management',
'检查结果': 'Inspection results',
'箱号': 'Box number',
'装箱数量': 'Packing quantity',
'建立时间': 'Establishment time',
'累计入库数量': 'Accumulated inbound quantity',
'入库单据': 'Receipt documents',
'出库单据': 'Outbound documents',
'箱子容量': 'Box capacity',
'维修工具': 'Maintenance tools',
'维修次数': 'Repair frequency',
'是否返修': 'Whether to repair or not',
'工序名称': 'Process name',
'缺陷数量': 'Number of defects',
'检验结果': 'Inspection results',
'维修结果': 'Repair results',
'维修日期': 'Repair date',
'外壳序号': 'Shell serial number',
'维修用户': 'Repair user',
'请输入成品编号': 'Please enter the finished product number',
'请输入条码号': 'Please enter the barcode number',
'请输入批号': 'Please enter the batch number',
'请输入箱号': 'Please enter the container number',
'请输入钢网编号': 'Please enter the steel mesh number',
'请输入站位': 'Please enter the station location',
'请选择操作类型': 'Please select the operation type',
'请输入入库单据': 'Please enter the warehouse receipt',
'请输入出库单据': 'Please enter the outbound document',
'请选择工序': 'Please select a process',
'请输入位号': 'Please enter the tag number',
'合计(含税)': 'Total (including tax)',
'成品入库数': 'Finished goods received',
'成品签收数': 'Number of signed for finished products',
'入库单号': 'Warehouse entry number',
'入库数量': 'Inventory quantity',
'签收数量': 'Received quantity',
'签收时间': 'Signing time',
'签收单号': 'Receipt number',
'不输入则系统分配默认单号': 'If not entered, the system will assign a default tracking number',
'操作成功': 'Operation successful',
'详情删除成功！': 'Details deleted successfully!',
'其他费用明细删除成功！': 'Other expense details deleted successfully!',
'详情保存成功！': 'Details saved successfully!',
'其他费用明细保存成功！': 'Other expense details saved successfully!',
'模块码': 'Module code',
'请输入模块码': 'Please enter the module code',
'请输入含税单价': 'Please enter the unit price including tax',
'工作台':'workbench',
'邮箱':'Email',
'微信':'wechat',
'验证码':'captcha',
'绑定':'bind',
'解绑':'unbinding',
'请输入邮箱':'Please enter the email',
'请输入微信':'Please enter the wechat',
'请输入验证码':'Please enter the captcha',
'秒后重试':'seconds later',
'发送验证码':'send a verification code',
'用户名':'username',
'密码':'password',
'手机号码':'mobile phone number',
'所属供应商':'supplier',
'个人信息':'Personal information',
'账号绑定':'account binding',
'已绑定':'bind',
'未绑定':'unbound',
'绑定邮箱，可及时接收订单动态':'bind the mailbox to receive the order dynamics in time',
'绑定微信，可及时接收订单动态':'bind we chat you can receive order dynamics in time',
'请输入正确的手机号':'please enter a valid mobile phone number',
'修改成功':'the modification was successful',
'修改失败':'the modification failed',
'请查看电子邮箱获取验证码':'please check your email address for a verification code',
'请查看微信验证':'please check we chat verification',
'请输入电子邮件地址':'please enter an email address',
'请输入有效的电子邮件地址':'please enter a valid email address',
'请输入微信账号':'please enter your we chat account',
'请选择送货单':'please select a delivery note',
'关闭标记':'turn off tagging',
'待办处理':'handle on behalf of the agency',
'去下单':'go to place an order',
'去签收':'go and sign for it',
'去处理':'go and deal with it',
'订单号':'order number',
'事物类型':'thing type',
'代签收':'sign for the receipt',
'待齐套':'to be set',
'以排期':'to schedule',
'生产不良原因统计':'statistics on the causes of production defects',
'IPQC总不良数':'the total number of ipqc defects',
'工单完成进度':'the progress of the work order completion',
'订单数量':'order quantity',
'日产量达成情况':'daily production achievement',
'目标数':'number of targets',
'实际数':'actuals',
'产量完成环比分析':'month on month analysis of production was completed',
'当天':'that day',
'7天':'7 days',
'便携引导':'portable guidance',
'委外订单下达':'outsourced order placement',
'加工订单录入,实现全流程溯源管理':'processing order entry to achieve whole process traceability management',
'物料齐套':'the material is complete',
'订单计划排期,工单物料齐套':'the order is scheduled and scheduled and the work order materials are complete',
'通过条码查看生产过程信息':'view production process information by barcode',
'订单对账':'order reconciliation',
'订单对账及结束订单':'order reconciliation and order closing',
'预警信息':'early warning information',
'订单结算统计':'order settlement statistics',
'物料欠料明细': 'Material shortage details',
'日记账号': 'Diary account',
'导出明细': 'Export details',
'欠料': 'Material shortage',
'全部': 'All',
'物料齐套处理': 'Material completeness processing',
'齐套方式': 'Completeness method',
'请选择齐套方式': 'Please select completeness method',
'预计到料时间': 'Expected arrival time',
'联系人': 'Contact person',
'联系方式': 'Contact information',
'请选择联系方式': 'Please select contact information',
'当前库存': 'Current inventory',
'工单需求数': 'Work order demand',
'差异数': 'Difference number',
'首件': 'First piece',
'工单组名称': 'Work order group name',
'工单组编号': 'Work order group number',
'状态': 'Status',
'是否已计算': 'Whether calculated',
'已开始': 'Started',
'发料': 'Issue material',
'已发料': 'Material issued',
'下线': 'Offline',
'备料': 'Prepare material',
'激活': 'Activate',
'客户齐套': 'Customer completeness',
'齐套确认': 'Completeness confirmation',
'请选择时间':'please select a time',
'请选择方式':'please select a method',
'微信扫一扫':'wechat sweep',
'未完成':'incompletion',
'完成':'finish',
'未分类': 'Uncategorized',
'不良原因': 'Defect Reasons',
'订单交期超期提醒': 'Overdue Order Reminder',
'工单总需求数': 'Total Work Order Demand',
'理论库存': 'Theoretical Inventory',
'允损数': 'Allowed Loss',
'余数': 'Remainder',
'替代主料': 'Alternative Main Ingredient',
'齐套': 'Complete Set',
'必须选择预计到料时间': 'Must select the estimated arrival time',
'必须选择齐套方式': 'Must select the complete set method',
'必须填写联系人': 'Must fill in the contact person',
'必须填写联系方式': 'Must fill in the contact information',
'是否是替代料':'whether it is a substitute material',
'已齐套':'Complete set',
'齐套状态':'ready to go status',
'齐套单号': 'Complete set of tracking numbers',
'加载中...': 'Loading...',
'为了更方便您关注订单的实时状态，建议您进入个人中心完善资料，系统将更好的为您服务！': 'For the convenience of monitoring the real-time status of your order, we suggest that you enter your personal center to complete your information. The system will better serve you!',
'请设置密码': 'Please set a password',
'请设置确认密码': 'Please set a confirmation password',
'订单交付超期提醒': 'Order Delivery Overdue Reminder',
'易损物料最低库存预警': 'Low Inventory Warning for Perishable Materials',
'订单超时未下单提醒': 'Order Timeout Reminder',
'订单未签收提醒': 'Order Unreceived Reminder',
'订单已完成加工,未关闭提醒': 'Order Processing Complete, Unfinished Reminder',
'微信公众号': 'WeChat official account',
'绑定微信公众号，可及时接收订单动态': 'Bind WeChat official account to receive order dynamics in time',
'微信小程序': 'WeChat Mini Program',
'绑定微信小程序，可随时查看订单动态': 'Bind WeChat mini program to view order updates at any time',
'请输入原始密码': 'Please enter your current password',
'请输入新密码': 'Please enter your new password',
'请再次输入新密码': 'Please re-enter your new password',
'密码修改': 'Password modification',
'信息修改': 'Information modification',
'旧密码': 'Old password',
'新密码': 'New password',
'确认密码': 'Confirm password',
'修改密码': 'Change password',
'使用账号登录': 'Log in with account',
'二维码获取失败': 'QR code acquisition failed',
'二维码已过期': 'The QR code has expired',
'重新获取二维码': 'Retrieve QR code again',
'调用微信登录接口失败': 'Failed to call WeChat login interface',
'获取imes系统用户信息失败': 'Failed to retrieve user information from the imes system',
'获取imes系统账号信息失败': 'Failed to obtain IMEI system account information',
'获取imes系统租户信息失败': 'Failed to retrieve tenant information from the IMES system',
'您的微信还没有绑定系统账号，请用系统账号登陆后，在个人中心进行微信账号绑定': 'Your WeChat account has not been linked to the system account yet. Please log in with the system account and bind your WeChat account in the personal center',
'发送短信配置': 'Sending SMS configuration',
'发送短信手机号': 'Send SMS with phone number',
'请输入手机号': 'Please enter your phone number',
'是否开启订单变更短信通知': 'Do you want to enable SMS notification for order changes',
'发送短信服务': 'Sending SMS service',
'工单排期': 'Work order scheduling',
'工单生产': 'Work order production',
'工单完成': 'Work order completed',
'工单签收': 'Sign for work order',
'请输入完整的手机号码': 'Please enter your complete phone number',
'验证码获取成功': 'Verification code obtained successfully',
'绑定手机号': 'Bind phone number',
'解绑手机号': 'Unbind phone number',
'验证当前手机号': 'Verify current phone number',
'修改手机号': 'Change phone number',
'开启': 'open',
'工单完工': 'Work order completion',
'手机号': 'cell-phone number',
'获取验证码': 'Obtain verification code',
'验证': 'verification',
'短信拒收时间': 'SMS rejection time',
}